<p-toast [baseZIndex]="10000"></p-toast>

<div class="container-fluid" [@fadeIn]="true">
  @if(isLoading){
    <p-progressSpinner class="mt-3 flex justify-content-center"></p-progressSpinner>
  }

  <div class="row d-flex justify-content-center">
    <div class="col-10" *ngIf="!isLoading">
      <div class="row">
        <div class="col-1 mb-3">
          <p-button severity="secondary" icon="pi pi-undo" type="button" label="{{ 'Back' | translate }}" (click)="goBack()"> </p-button>
        </div>
      </div>
      <p-card header="{{ 'Task Detail' | translate }}">
        <hr class="mt-4">

        <!-- Detail -->
        <div>
          <app-payment-form
            [payment]="memoPayment"
            (maxRelatedSelectionMethod)="maxRelatedSelection()"
            [diffValueMaxRelated]="diffValueMaxRelated"
            [isMaxRelatedHigherMax]="isMaxRelatedHigherMax"
            [isMaxRelatedZero]="isMaxRelatedZero"
            [defaultMaxRelated]="defaultMaxRelated"
            [diffCountry]="diffCountry"
            [isTaskDetail]="true"
            [isNewPayment]="false"
            [isPeriodRangePayment]="false"
            [isLoadingRemotes]="isLoadingRemotes"
            [agentsMacroGroupsList]="agentsMacroGroupsList"
            [isTaskEditable]="isTaskEditable"
            [enableRemotes]="enableRemotes"
            [uploadRemoteList]="uploadRemoteList"
            [remoteResponseList]="remoteResponseList"
            [endTaskDateNotHigherThanStartDate]="endTaskDateNotHigherThanStartDate"
            [endTaskDateNotHigherThanToday]="endTaskDateNotHigherThanToday"
            (getRemotes)="getRemotes()"
            (setEnableRemotesMethod)="setEnableRemotes($event)"
            (setEndTaskDateNotHigherThanStartDateMethod)="setEndTaskDateNotHigherThanStartDate()"
            (setEndTaskDateNotHigherThanTodayMethod)="setEndTaskDateNotHigherThanToday()"
            >
          </app-payment-form>

          <div class="offset-9 col-3 mb-4 d-block d-flex justify-content-end">
            @if(isTaskEditable){
              <p-button severity="secondary" class="mr-3" type="button" icon="pi pi-times" label="{{ 'Common.Cancel' | translate }}" [disabled]="!isTaskEditable" (click)="cancelPage()"></p-button>
            } @else {
              <p-button severity="primary"   class="mr-3" type="button" icon="pi pi-pencil" label="{{ 'Common.Edit' | translate }}" [disabled]="isTaskEditable || memoPayment?.templateExpired" (click)="editPage()"></p-button>
            }
            <p-button   severity="primary"   class="mr-3" type="button" icon="pi pi-save" label="{{ 'Common.Save' | translate }}" [disabled]="checkButtonSaveDisabled()" (click)="savePayment()"></p-button>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>
